{
  "version": 1,
  "asset_id": "c1b467b8-889d-4add-a680-9c5ecbefad1d",
  "project_id": "7580f3ab-e7a4-418d-abe6-5eb616986e51",
  "url": "/__l5e/assets-v1/c1b467b8-889d-4add-a680-9c5ecbefad1d/destination-roofing-blue-metal-roof-lecanto-fl-768w.webp",
  "r2_key": "a/v1/7580f3ab-e7a4-418d-abe6-5eb616986e51/c1b467b8-889d-4add-a680-9c5ecbefad1d/destination-roofing-blue-metal-roof-lecanto-fl-768w.webp",
  "original_filename": "destination-roofing-blue-metal-roof-lecanto-fl-768w.webp",
  "size": 50840,
  "content_type": "image/webp",
  "created_at": "2026-07-16T20:37:18Z"
}
